import { getUserDetails } from '../../api';
import type { DecodedToken } from '../../api/hooks/login-sign-up/interface';
import { identifyTracerxUser } from '../setTracerxUser';
export const decodeAccessToken = async (token: string): Promise<DecodedToken> => {
  const response = await getUserDetails(token);
  identifyTracerxUser({
    userId: response.userId,
    groupId: response.groupId,
    email: response.email,
  });

  return {
    userId: response.userId,
    userSeqId: response.userSeqId,
    legacyUserSeqId: response.legacyUserSeqId,
    username: response.username,
    name: response.name,
    loginType: response.loginType,
    userMetadata: response.userMetadata,
    sourceType: response?.sourceType,
  };
};

export const normalizeName = (name: string | null) => {
  if (!name) {
    return '';
  }
  return name
    .toLowerCase()
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};
